// extracted by mini-css-extract-plugin
export default {"dcButtonContainer":"dcbutton_dcButtonContainer__JJ4c-","dcButton":"dcbutton_dcButton__odeZi"};